import { useState } from "react";
import "./App.css";
import Block from "./Block";
function App() {
  const [squares, setSquares] = useState(Array(9).fill(null));
  const [isX, setIsX] = useState(true);
  const [isPlayersTurn, setIsPlayersTurn] = useState(true);
  const [showStartScreen, setShowStartScreen] = useState(true);
  const [singlePlayer, setSinglePlayer] = useState(false);
  const [, setDoublePlayer] = useState(false);
  const [toss, setToss] = useState(false);
  const [tossResult, setTossResult] = useState("");
  const [winningLine, setWinningLine] = useState(null);
  const [gameResult, setGameResult] = useState("");
  const [winner, setWinner] = useState(null);
  const winnerCondition = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [2, 4, 6],
    [0, 4, 8],
  ];
  const getWinLine = (winningLine) => {
    if (!winningLine) return null;
    const [a, b, c] = winningLine;
    if (a === 0 && b === 1 && c === 2) return { x1: 0, y1: 16.67, x2: 100, y2: 16.67 }; // top row
    if (a === 3 && b === 4 && c === 5) return { x1: 0, y1: 50, x2: 100, y2: 50 }; // middle row
    if (a === 6 && b === 7 && c === 8) return { x1: 0, y1: 83.33, x2: 100, y2: 83.33 }; // bottom row
    if (a === 0 && b === 3 && c === 6) return { x1: 16.67, y1: 0, x2: 16.67, y2: 100 }; // left col
    if (a === 1 && b === 4 && c === 7) return { x1: 50, y1: 0, x2: 50, y2: 100 }; // middle col
    if (a === 2 && b === 5 && c === 8) return { x1: 83.33, y1: 0, x2: 83.33, y2: 100 }; // right col
    if (a === 0 && b === 4 && c === 8) return { x1: 16.67, y1: 16.67, x2: 83.33, y2: 83.33 }; // diag \
    if (a === 2 && b === 4 && c === 6) return { x1: 83.33, y1: 16.67, x2: 16.67, y2: 83.33 }; // diag /
    return null;
  };

  function playWithComputer() {
    setToss(false);
    setTossResult("");
    setGameResult("");
    setSquares(Array(9).fill(null));
    setIsPlayersTurn(true);
    console.log("Play with computer");
    setShowStartScreen(false);
    setSinglePlayer(true);
    setDoublePlayer(false);
  }
  function playWithAnotherPlayer() {
    setToss(true);
    setGameResult("");
    setSquares(Array(9).fill(null));
    setIsX(true);
    console.log("play with another player");
    setShowStartScreen(false);
    setDoublePlayer(true);
    setSinglePlayer(false);
  }

  function handleMove(index) {
    if (winningLine || gameResult) return;
    if (squares[index] !== null) return;
    if (singlePlayer) {
      if (!isPlayersTurn) return;
      playSinglePlayer(index);
    } else {
      playDoublePlayer(index);
    }
  }


  const calculateWinner = (squaresCopy) => {
    for (let i = 0; i < winnerCondition.length; i++) {
      const [a, b, c] = winnerCondition[i];
      if (
        squaresCopy[a] !== null &&
        squaresCopy[a] === squaresCopy[b] &&
        squaresCopy[a] === squaresCopy[c]
      ) {
        return squaresCopy[a];
      }
    }
    return null;
  };

  const getWinningLine = (squaresCopy) => {
    for (let i = 0; i < winnerCondition.length; i++) {
      const [a, b, c] = winnerCondition[i];
      if (
        squaresCopy[a] !== null &&
        squaresCopy[a] === squaresCopy[b] &&
        squaresCopy[a] === squaresCopy[c]
      ) {
        return [a, b, c];
      }
    }
    return null;
  };

  const isBoardFull = (squaresCopy) => squaresCopy.every((cell) => cell !== null);

  const minimax = (board, isComputer) => {
    const winner = calculateWinner(board);
    if (winner === "X") return { score: 1 };
    if (winner === "0") return { score: -1 };
    if (isBoardFull(board)) return { score: 0 };

    if (isComputer) {
      let best = { score: -Infinity, move: -1 };
      for (let i = 0; i < board.length; i++) {
        if (board[i] === null) {
          board[i] = "X";
          const result = minimax(board, false);
          board[i] = null;
          if (result.score > best.score) {
            best = { score: result.score, move: i };
          }
        }
      }
      return best;
    }

    let best = { score: Infinity, move: -1 };
    for (let i = 0; i < board.length; i++) {
      if (board[i] === null) {
        board[i] = "0";
        const result = minimax(board, true);
        board[i] = null;
        if (result.score < best.score) {
          best = { score: result.score, move: i };
        }
      }
    }
    return best;
  };

  const getBestComputerMove = (squaresCopy) => {
    let bestScore = -Infinity;
    let bestMoves = [];
    for (let i = 0; i < squaresCopy.length; i++) {
      if (squaresCopy[i] === null) {
        const boardCopy = [...squaresCopy];
        boardCopy[i] = "X";
        const score = minimax(boardCopy, false).score;
        if (score > bestScore) {
          bestScore = score;
          bestMoves = [i];
        } else if (score === bestScore) {
          bestMoves.push(i);
        }
      }
    }
    return bestMoves[Math.floor(Math.random() * bestMoves.length)];
  };

  const makeComputerMove = (squaresCopy) => {
    const bestMove = getBestComputerMove(squaresCopy);
    if (bestMove < 0) return squaresCopy;
    const nextSquares = [...squaresCopy];
    nextSquares[bestMove] = "X";
    return nextSquares;
  };

  const computerFirstMove = () => {
    const nextSquares = makeComputerMove(Array(9).fill(null));
    setSquares(nextSquares);
    return nextSquares;
  };

  function playSinglePlayer(index) {
    if (!isPlayersTurn || squares[index] !== null) return;

    setIsPlayersTurn(false);
    const playerSquares = [...squares];
    playerSquares[index] = "0";
    setSquares(playerSquares);

    if (calculateWinner(playerSquares) === "0") {
      setWinningLine(getWinningLine(playerSquares));
      setWinner("0");
      setGameResult("You won");
      return;
    }

    if (isBoardFull(playerSquares)) {
      setGameResult("<strong>It’s a draw</strong>");
      return;
    }

    // Add 200ms pause before computer move
    setTimeout(() => {
      const nextSquares = makeComputerMove(playerSquares);
      setSquares(nextSquares);
      setIsPlayersTurn(true);

      if (calculateWinner(nextSquares) === "X") {
        setWinningLine(getWinningLine(nextSquares));
        setWinner("X");
        setGameResult("<strong>Computer wins</strong>");
        return;
      }

      if (isBoardFull(nextSquares)) {
        setGameResult("<strong>It’s a draw</strong>");
      }
    }, 200);
  }

  function playDoublePlayer(index) {
    const squaresCopy = [...squares];
    squaresCopy[index] = isX ? "X" : "0";
    setSquares(squaresCopy);
    setIsX(!isX);

    let didXWin = false;
    let didZeroWin = false;
    winnerCondition.forEach((arr) => {
      let xCount = 0;
      let zeroCount = 0;
      arr.forEach((ele) => {
        if (squaresCopy[ele] === "X") {
          xCount++;
        }
        if (squaresCopy[ele] === "0") {
          zeroCount++;
        }
      });

      if (xCount === 3) {
        didXWin = true;
        return;
      }
      if (zeroCount === 3) {
        didZeroWin = true;
        return;
      }
    });

    if (didXWin) {
      setWinningLine(getWinningLine(squaresCopy));
      setWinner("X");
      setGameResult("Player X won");
      return;
    }
    if (didZeroWin) {
      setWinningLine(getWinningLine(squaresCopy));
      setWinner("0");
      setGameResult("Player O won");
      return;
    }

    let ifSquaresCompleted = true;
    squaresCopy.forEach((element) => {
      if (element === null) ifSquaresCompleted = false;
    });
    if (ifSquaresCompleted) {
      setGameResult("Match drawn");
      return;
    }
  }
  const onReset = () => {
    var elements = document.getElementsByClassName("block");

    // Iterate through the elements and reset pointer events
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.pointerEvents = "auto";
    }

    setWinningLine(null);
    setGameResult("");
    setWinner(null);
    if (singlePlayer) {
      setSquares(Array(9).fill(null));
      setToss(false);
      setTossResult("");
      setIsPlayersTurn(true);
    } else {
      setSquares(Array(9).fill(null));
      setIsX(true);
    }
  };

  function performToss() {
    const computerWon = Math.random() < 0.5;
    const result = computerWon ? "Computer won the toss" : "Player won the toss";
    setTossResult(result);
    setIsPlayersTurn(!computerWon);

    setTimeout(() => {
      setTossResult(result);
      setToss(true);

      if (computerWon) {
        computerFirstMove();
        setIsPlayersTurn(true);
      } else {
        setSquares(Array(9).fill(null));
      }
    }, 1000);
  }

  const winLine = getWinLine(winningLine);

  return (
    <div className="app-shell">
      {showStartScreen ? (
        <>
          <div className="hero">
            <h1 className="title">Tic Tac Toe</h1>
            <p className="subtitle">Select a mode and start a clean, easy-to-read game board. The interface stays simple and responsive on any device.</p>
            <div className="mode-buttons">
              <button className="mode-button" onClick={playWithComputer}>Single Player</button>
              <button className="mode-button secondary" onClick={playWithAnotherPlayer}>Two Player</button>
            </div>
          </div>
        </>
      ) : (
        <>
          {singlePlayer && !toss && (
            <div className="status-card">
              <h2 className="status-title">Toss For First Move</h2>
              {tossResult === "" ? (
                <button className="action-button" onClick={performToss}>Toss</button>
              ) : (
                <p className="status-message">{tossResult}</p>
              )}
            </div>
          )}
          {toss && (
            <div className="board-shell" style={{ position: 'relative' }}>
              <div className="board-container">
                <div className="board">
                  <div className="box">
                    <Block value={squares[0]} onClick={() => handleMove(0)} id="0" isWinning={winningLine?.includes(0)} winner={winner} />
                    <Block value={squares[1]} onClick={() => handleMove(1)} id="1" isWinning={winningLine?.includes(1)} winner={winner} />
                    <Block value={squares[2]} onClick={() => handleMove(2)} id="2" isWinning={winningLine?.includes(2)} winner={winner} />
                  </div>

                  <div className="box">
                    <Block value={squares[3]} onClick={() => handleMove(3)} id="3" isWinning={winningLine?.includes(3)} winner={winner} />
                    <Block value={squares[4]} onClick={() => handleMove(4)} id="4" isWinning={winningLine?.includes(4)} winner={winner} />
                    <Block value={squares[5]} onClick={() => handleMove(5)} id="5" isWinning={winningLine?.includes(5)} winner={winner} />
                  </div>

                  <div className="box">
                    <Block value={squares[6]} onClick={() => handleMove(6)} id="6" isWinning={winningLine?.includes(6)} winner={winner} />
                    <Block value={squares[7]} onClick={() => handleMove(7)} id="7" isWinning={winningLine?.includes(7)} winner={winner} />
                    <Block value={squares[8]} onClick={() => handleMove(8)} id="8" isWinning={winningLine?.includes(8)} winner={winner} />
                  </div>
                </div>
                {winLine && (
                  <svg
                    className="win-line-svg"
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      pointerEvents: 'none',
                      zIndex: 10
                    }}
                    viewBox="0 0 100 100"
                  >
                    <line
                      x1={winLine.x1}
                      y1={winLine.y1}
                      x2={winLine.x2}
                      y2={winLine.y2}
                      stroke={winner === 'X' ? "#3b82f6" : "#ef4444"}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeDasharray="100"
                      strokeDashoffset="100"
                    />
                  </svg>
                )}
              </div>
              <div className="board-footer">
                {(winningLine || gameResult) ? (
                  <div className="status-banner">
                    <span dangerouslySetInnerHTML={{__html: gameResult || "Game over — the winning row is highlighted on the board."}}></span>
                    <button className="reset-button secondary" onClick={onReset}>Play Again</button>
                  </div>
                ) : (
                  <>
                    <button className="reset-button" onClick={onReset}>Reset</button>
                    {!singlePlayer && !gameResult && (
                      <div className="status-turn">
                        Player {isX ? "X" : "O"}'s turn
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default App;
